import { Configuration, EndpointsApi, AccountsApi, BillingApi } from './api-sdk-patched';
import { clearAuthSession, getStoredToken } from './utils/authStorage';

let isHydrating = true;

export function setHydrationComplete() {
    isHydrating = false;
}

export function getSdkConfig(): Configuration {
    const apiBase = import.meta.env.VITE_API_BASE || 'http://127.0.0.1:8000';

    const config = new Configuration({
        basePath: apiBase,
        accessToken: () => {
            return getStoredToken() || '';
        },
        baseOptions: {
            headers: {
                'Accept': 'application/json',
            }
        }
    });

    return config;
}

const config = getSdkConfig();
export const client = new EndpointsApi(config);
export const accountsClient = new AccountsApi(config, undefined, (client as any).axios);
export const billingClient = new BillingApi(config, undefined, (client as any).axios);

// Add interceptor to ensure token is always fresh and correctly formatted
const axiosInstance = (client as any).axios;
if (axiosInstance) {
    // Request interceptor - adds Bearer token
    axiosInstance.interceptors.request.use((req: any) => {
        const token = getStoredToken();
        if (token) {
            req.headers.Authorization = `Bearer ${token}`;
        }
        return req;
    });

    // Response interceptor - handles 401 errors
    axiosInstance.interceptors.response.use(
        (response: any) => response,
        (error: any) => {
            // Only clear session on 401 if we're not in the initial hydration phase
            // This prevents logout during app refresh when token is still valid
            if (error.response?.status === 401 && !isHydrating) {
                console.error('401 Unauthorized - Redirecting to signin');
                clearAuthSession();
                window.location.href = '/signin';
            }
            return Promise.reject(error);
        }
    );
}
